import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a495fc5ca334e0014ae07d3_1783354875462_1d1f43c9/learnerlinksa/src/app/school-registration-page/components/SchoolRegistrationClient.tsx");
